import { Controller } from '@hotwired/stimulus'
import { applyPhoneMaskValue, createPhoneMask, validatePhoneInput } from '../lib/phone_input'

export default class extends Controller {
  static values = {
    required: Boolean
  }

  connect() {
    if (!(this.element instanceof HTMLInputElement)) return

    this.form = this.element.form
    this.mask = createPhoneMask(this.element)
  applyPhoneMaskValue(this.mask, this.element.value, { defaultPrefix: true })

    this.handleInput = this.handleInput.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

    this.element.addEventListener('input', this.handleInput)
    this.element.addEventListener('blur', this.handleBlur)
    this.form?.addEventListener('submit', this.handleSubmit)

    this.syncValidity()
  }

  disconnect() {
    this.element.removeEventListener('input', this.handleInput)
    this.element.removeEventListener('blur', this.handleBlur)
    this.form?.removeEventListener('submit', this.handleSubmit)
    this.mask?.destroy()
  }

  handleInput() {
    this.syncValidity()
  }

  handleBlur() {
    this.syncValidity({ force: true })
  }

  handleSubmit(event) {
    const validation = this.validationResult()

    if (!validation.valid) {
      event.preventDefault()
      this.syncValidity({ force: true })
      this.element.reportValidity()
      return
    }

    this.element.value = validation.submitValue
  }

  validationResult() {
    return validatePhoneInput(this.mask?.value || this.element.value, {
      required: this.requiredValue || this.element.required
    })
  }

  syncValidity({ force = false } = {}) {
    const validation = this.validationResult()
    const shouldShowError = force || this.element.value.trim().length > 0

    this.element.setCustomValidity(!validation.valid && shouldShowError ? validation.message : '')
  }
}